module.exports = __webpack_public_path__ + "img/Indonesia.dab30adb.svg";